import React from 'react'

const Manage = () => {
  return (
    <>
    <h1>Manage</h1>
    <p>hi there, my name is diksha </p>
    </>
  )
}

export default Manage